import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Add from "icons/add-circle.svg";
import Dashboard from "../../../components/Template/Dashboard";
import Button from "components/Button";
import Loading from "components/Loading";
import { listAdmins } from "services/admin";
import NoData from "components/NoData";
import ModalStatus from "./ModalStatus";
import TableAdmin from "./TableAdmin";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {};

const BridgeTalkAdminIndex: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [dataList, setDataList] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>("");

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [page, setPage] = useState("1");

  const list = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await listAdmins(page);
      setDataList(data.result);
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    list();
  }, [list]);

  return (
    <Dashboard
      title={"Bridge Talk Admin"}
      breadcrumb={[]}
      info={dataList.length}
      subInfo={"Users"}
      children={
        <Fragment>
          <Loading loading={loading} />
          <ModalStatus
            show={show}
            setShow={setShow}
            setLoading={setLoading}
            deleteId={deleteId}
          />
          <div className="flex flex-row w-full justify-between mt-10">
            <div className="flex flex-col my-auto w-72"></div>
            <div className="flex flex-col my-auto">
              <Button
                label={"Add Account"}
                iconLeft={Add}
                className="bg-bt-green text-bt-white h-14 w-40 font-sora rounded-full"
                onClick={() => {
                  history.push("/bridge-talk-admin/create");
                }}
              />
            </div>
          </div>
          {dataList.length > 0 ? (
            <TableAdmin
              dataList={dataList}
              setShow={setShow}
              setDeleteId={setDeleteId}
            />
          ) : (
            <NoData />
          )}
          <ToastContainer />
        </Fragment>
      }
    />
  );
};

export default BridgeTalkAdminIndex;
